import React from 'react'

import Reflux from 'reflux-react-16'
import _ from 'lodash'

import {Button, Panel, ListItem, H3, S2, P, H5, Card} from '../../../../components/UI/index.js'
import {formSpacing, FormStack, Toggle, Input, Select, TextArea} from '../../../../components/UI/forms/index.js'
import FAQModal from '../../../../components/resellers/FAQModal.js'

class TrackTrace extends Reflux.Component {
    onChangeChecked(path, event) {
        const reseller = {...this.props.reseller}

        _.set(reseller.settings, path, event.target.checked)

        this.props.onChange(reseller, path)
    }

    onChangeValue(path, event) {
        const reseller = {...this.props.reseller}

        if (path === 'orders.trackTrace.timeFrame') {
            _.set(reseller.settings, path, parseInt(event.target.value))
        } else {
            _.set(reseller.settings, path, event.target.value)
        }

        this.props.onChange(reseller)
    }

    onSaveValue(path, event) {
        const reseller = {...this.props.reseller}

        if (event) {
            if (path === 'orders.trackTrace.timeFrame') {
                _.set(reseller.settings, path, parseInt(event.target.value))
            } else {
                _.set(reseller.settings, path, event.target.value)
            }
        }

        this.props.onChange(reseller, path)
    }

    onUpdateFAQ(faq, index) {
        const reseller = {...this.props.reseller}

        if (typeof index === 'number') {
            reseller.settings.orders.trackTrace.faq[index] = faq
        } else {
            reseller.settings.orders.trackTrace.faq = reseller.settings.orders.trackTrace.faq || []
            reseller.settings.orders.trackTrace.faq.push(faq)
        }

        this.props.onChange(reseller, 'orders.trackTrace.faq')
    }

    onRemoveFAQ(index) {
        const reseller = {...this.props.reseller}

        reseller.settings.orders.trackTrace.faq.splice(index, 1)

        this.props.onChange(reseller, 'orders.trackTrace.faq')
    }

    render() {
        const {reseller} = this.props

        return (
            <Card shadow style={{width: 600, padding: 24, height: 'fit-content'}}>

                <H3 style={{marginBottom: 36}}>Track & Trace Pagina</H3>

                <H5 style={{marginBottom: 24}}>Algemeen</H5>

                <FormStack>
                    <Select
                        label='Status icoon onderweg'
                        info='Deze instelling bepaalt of er een fiets- of autoicoon wordt getoond op de Track & Trace pagina voor de status onderweg.'
                        value={reseller.settings.orders.trackTrace.outForDeliveryStatusIcon}
                        onChange={this.onSaveValue.bind(this, 'orders.trackTrace.outForDeliveryStatusIcon')}
                    >
                        <option value='bike'>Fiets</option>
                        <option value='cargo-bike'>Bakfiets</option>
                        <option value='car'>Auto</option>
                    </Select>

                    <Select
                        label='Tijdvak voor bezorging'
                        info='1/3e van het tijdvak wordt vóór de berekende ETA genomen, en 2/3e van het tijdvak na de ETA.'
                        value={reseller.settings.orders.trackTrace.timeFrame || 60}
                        onChange={this.onSaveValue.bind(this, 'orders.trackTrace.timeFrame')}
                    >
                        <option value={15}>15 minuten</option>
                        <option value={30}>30 minuten</option>
                        <option value={45}>45 minuten</option>
                        <option value={60}>1 uur</option>
                        <option value={120}>2 uur</option>
                        <option value={240}>4 uur</option>
                    </Select>

                    <Toggle
                        label='Foto van levering verbergen op track & trace pagina'
                        info='Indien ingeschakeld, wordt de foto van de levering niet getoond op de track & trace pagina.'
                        checked={reseller.settings.orders.trackTrace.hidePhoto}
                        onChange={this.onChangeChecked.bind(this, 'orders.trackTrace.hidePhoto')}
                    />
                </FormStack>

                <H5 style={{marginBottom: 24, marginTop: 36}}>Status berichten</H5>

                <FormStack>
                    <TextArea
                        label='Ophalen niet gelukt'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.pickupNotCompletedMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.pickupNotCompletedMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.pickupNotCompletedMessage')}
                    />

                    <TextArea
                        label='Ophalen niet thuis'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.pickupNotHomeMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.pickupNotHomeMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.pickupNotHomeMessage')}
                    />

                    <TextArea
                        label='Ophalen geannuleerd'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.pickupCancelledMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.pickupCancelledMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.pickupCancelledMessage')}
                    />

                    <TextArea
                        label='Bezorgen niet gelukt (Nieuwe bezorgpoging)'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.deliveryNotCompletedRescheduleMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.deliveryNotCompletedRescheduleMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.deliveryNotCompletedRescheduleMessage')}
                    />

                    <TextArea
                        label='Bezorgen niet gelukt (Foutief adres)'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.deliveryNotCompletedRetourMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.deliveryNotCompletedRetourMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.deliveryNotCompletedRetourMessage')}
                    />

                    <TextArea
                        label='Bezorgen niet gelukt (Geweigerd)'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.deliveryNotCompletedRefusedMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.deliveryNotCompletedRefusedMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.deliveryNotCompletedRefusedMessage')}
                    />

                    <TextArea
                        label='Bezorgen niet gelukt (Geen vervolg)'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.deliveryNotCompletedNoFollowUpMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.deliveryNotCompletedNoFollowUpMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.deliveryNotCompletedNoFollowUpMessage')}
                    />

                    <TextArea
                        label='Bezorgen niet thuis (Nieuwe bezorgpoging)'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.deliveryNotHomeRescheduleMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.deliveryNotHomeRescheduleMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.deliveryNotHomeRescheduleMessage')}
                    />

                    <TextArea
                        label='Bezorgen niet thuis (In bewaring)'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.deliveryNotHomeOnHoldMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.deliveryNotHomeOnHoldMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.deliveryNotHomeOnHoldMessage')}
                    />

                    <TextArea
                        label='Bezorgen niet thuis (Retour)'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.deliveryNotHomeRetourMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.deliveryNotHomeRetourMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.deliveryNotHomeRetourMessage')}
                    />

                    <TextArea
                        label='Bezorgen niet thuis (Geen vervolg)'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.deliveryNotHomeNoFollowUpMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.deliveryNotHomeNoFollowUpMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.deliveryNotHomeNoFollowUpMessage')}
                    />

                    <TextArea
                        label='Bezorgen geannuleerd'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.deliveryCancelledMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.deliveryCancelledMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.deliveryCancelledMessage')}
                    />

                    <TextArea
                        label='Manco'
                        rows={3}
                        value={reseller.settings.orders.trackTrace.deliveryMancoMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.deliveryMancoMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.deliveryMancoMessage')}
                    />
                </FormStack>

                <H5 style={{marginBottom: 24, marginTop: 36}}>Veelgestelde vragen</H5>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Toggle
                        label='Toon veelgestelde vragen op Track & Trace pagina'
                        checked={reseller.settings.orders.trackTrace.showFaq}
                        onChange={this.onChangeChecked.bind(this, 'orders.trackTrace.showFaq')}
                    />
                </FormStack>

                {reseller.settings.orders.trackTrace.showFaq &&
                    <>
                        <Panel style={{maxHeight: 500, overflowY: 'auto', marginBottom: 24}}>
                            {(reseller.settings.orders.trackTrace.faq || []).map((faq, index) => {
                                return (
                                    <ListItem key={`faq${index}`} onClick={() => this.faqModal.open(faq, index)}>
                                        <div>
                                            <P>{faq.question}</P>
                                            <S2>{faq.answer}</S2>
                                        </div>
                                    </ListItem>
                                )
                            })}
                        </Panel>

                        <Button
                            variant='outline'
                            icon='mdi mdi-plus'
                            label='Nieuwe FAQ'
                            onClick={() => this.faqModal.open()}
                        />
                    </>
                }

                <FAQModal
                    onSubmit={this.onUpdateFAQ.bind(this)}
                    onRemove={this.onRemoveFAQ.bind(this)}
                    ref={(ref) => this.faqModal = ref}
                />

                <H5 style={{marginBottom: 24, marginTop: 36}}>Footer bericht</H5>

                <FormStack>
                    <Input
                        label='Footer titel'
                        value={reseller.settings.orders.trackTrace.footerTitle}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.footerTitle')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.footerTitle')}
                    />

                    <TextArea
                        label='Footer tekst'
                        value={reseller.settings.orders.trackTrace.footerMessage}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.footerMessage')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.footerMessage')}
                    />
                </FormStack>

                <H5 style={{marginBottom: 24, marginTop: 36}}>Contactinformatie</H5>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Toggle
                        label='Bedrijfsadres verbergen op track & trace pagina'
                        info={`Indien ingeschakeld, wordt het adres van ${reseller.settings.companyName || reseller.name} niet getoond op de track & trace pagina.`}
                        checked={reseller.settings.orders.trackTrace.hideAddress}
                        onChange={this.onChangeChecked.bind(this, 'orders.trackTrace.hideAddress')}
                    />

                    <Input
                        label='Telefoon'
                        value={reseller.settings.orders.trackTrace.phone}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.phone')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.phone')}
                    />

                    <Input
                        label='Emailadres'
                        value={reseller.settings.orders.trackTrace.email}
                        onChange={this.onChangeValue.bind(this, 'orders.trackTrace.email')}
                        onBlur={this.onSaveValue.bind(this, 'orders.trackTrace.email')}
                    />
                </FormStack>
            </Card>
        )
    }
}

export default TrackTrace
